import { useSetAtom } from 'jotai';
import { useCallback, useMemo } from 'react';
import { indexRowChartDataAtom, indexRowRefreshVersionAtom } from '../../state';

export type UseIndexRowRefreshCommonOutput = {
  refreshIndexRows: () => void;
};

export const useIndexRowRefreshCommon = (): UseIndexRowRefreshCommonOutput => {
  const setIndexRowChartData = useSetAtom(indexRowChartDataAtom);
  const setIndexRowRefreshVersion = useSetAtom(indexRowRefreshVersionAtom);

  const refreshIndexRows = useCallback((): void => {
    setIndexRowChartData({});
    setIndexRowRefreshVersion(previousRefreshVersion => (previousRefreshVersion ?? 0) + 1);
  }, [setIndexRowChartData, setIndexRowRefreshVersion]);

  return useMemo<UseIndexRowRefreshCommonOutput>(
    () => ({
      refreshIndexRows,
    }),
    [refreshIndexRows],
  );
};
